import { HighlightCardsCarousel as HighlightCardsCarousel$1 } from '@cbhq/cdx-components';
import { getEntryProps } from '../utils/getEntryProps.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_CARDS_CAROUSEL_MODEL_ID = 'cdxHighlightCardsCarousel';
function HighlightCardsCarousel({
  autoplayInterval,
  autoplayLoop,
  cards: cardEntries = [],
  style,
  anchor,
  hasSpacingTop = false
}) {
  const cards = cardEntries.map(card => {
    const _getEntryProps = getEntryProps(card),
      headline = _getEntryProps.headline,
      description = _getEntryProps.description,
      media = _getEntryProps.media,
      ctaButton = _getEntryProps.ctaButton;
    const _getEntryProps2 = getEntryProps(ctaButton),
      url = _getEntryProps2.url,
      label = _getEntryProps2.label;
    return {
      headline,
      description,
      ctaLabel: label,
      ctaUrl: url,
      mediaUrl: media?.fields.file.url,
      mediaAlt: media?.fields.title
    };
  });
  return /*#__PURE__*/jsx(HighlightCardsCarousel$1, {
    autoplayInterval: autoplayInterval,
    autoplayLoop: autoplayLoop,
    hasSpacingTop: hasSpacingTop,
    style: style,
    anchor: anchor,
    cards: cards
  });
}
export { HIGHLIGHT_CARDS_CAROUSEL_MODEL_ID, HighlightCardsCarousel };
//# sourceMappingURL=HighlightCardsCarousel.js.map
